import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Users as UsersIcon, Trash2, ShieldCheck } from "lucide-react";

export default function TeamMembersTable({ users, currentUserId, isAdmin, onEdit, onChanged }) {
  const deleteUser = async (uid) => {
    if (!window.confirm("Delete this user?")) return;
    await api.delete(`/users/${uid}`);
    onChanged?.();
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <UsersIcon size={14} className="text-slate-500" />
        <h2 className="text-sm font-semibold" style={{ fontFamily: "Outfit" }}>Team Members</h2>
        <span className="text-xs text-slate-400 font-mono-data">({users.length})</span>
      </div>
      <div className="border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200 text-[11px] uppercase tracking-wider text-slate-500">
            <tr>
              <th className="text-left px-4 py-2.5">Name</th>
              <th className="text-left px-4 py-2.5">Email</th>
              <th className="text-left px-4 py-2.5">Role</th>
              <th className="text-left px-4 py-2.5">Assigned Clients</th>
              <th className="text-left px-4 py-2.5">Status</th>
              <th className="px-4 py-2.5 w-24"></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-b border-slate-100" data-testid={`user-row-${u.user_id}`}>
                <td className="px-4 py-2.5 font-medium">{u.name}</td>
                <td className="px-4 py-2.5 font-mono-data text-xs">{u.email}</td>
                <td className="px-4 py-2.5"><span className="status-pill" style={{ background: "#eff6ff", borderColor: "#bfdbfe", color: "#0a2540" }}><ShieldCheck size={10} /> {u.role}</span></td>
                <td className="px-4 py-2.5 text-xs text-slate-600">{(u.assigned_client_ids || []).length}</td>
                <td className="px-4 py-2.5"><span className={`status-pill ${u.active ? "status-completed" : "status-cancelled"}`}>{u.active ? "Active" : "Inactive"}</span></td>
                <td className="px-4 py-2.5 text-right">
                  {isAdmin && (
                    <>
                      <Button size="sm" variant="outline" className="rounded-sm h-7 mr-1" onClick={() => onEdit({ ...u })} data-testid={`btn-edit-user-${u.user_id}`}>Edit</Button>
                      {u.user_id !== currentUserId && (
                        <Button size="sm" variant="ghost" className="text-red-600 h-7 w-7 p-0" onClick={() => deleteUser(u.user_id)} data-testid={`btn-delete-user-${u.user_id}`}>
                          <Trash2 size={12} />
                        </Button>
                      )}
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
